import { Button } from "@progress/kendo-react-buttons"
import { Grid, GridCellProps, GridColumn, GridToolbar } from "@progress/kendo-react-grid"
import { useInternationalization } from "@progress/kendo-react-intl"
import { Tooltip } from "@progress/kendo-react-tooltip"
import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCol,
    MDBModal,
    MDBModalContent,
    MDBModalDialog,
    MDBModalHeader,
    MDBModalTitle
} from "mdbreact"
import {
    toggleDVSAModalAddEdit,
    dvsaToggleAddEditModal,
    dvsaDefaultInit,
    setSelectedExpetion
} from "../../containers/DvsaFees/dvsaFeesSlice"
import { RootState } from "../../rootReducer"
import { SpinnerFragment } from "../../shared/CommonItems"
import { useAppDispatch, useAppSelector } from "../../store"
import AlertToastr from "../Shared/alertToastr"
import { hasPermission } from "../Shared/permissionChecker"
import AddEditDvsaFee from "./addEditDVSAFee"

const DvsaFeeRecord = () => {
    const dispatch = useAppDispatch()

    const intl = useInternationalization()
    const dvsaFeeDefaults = useAppSelector((state: RootState) => state.containers.dvsaFees.dvsaFeeDefaults)
    const isDvsaModalOpen = useAppSelector((state: RootState) => state.containers.dvsaFees.dvsaModalOpen)
    const dvsaFeeGirdLoader = useAppSelector((state: RootState) => state.containers.dvsaFees.dvsaFeeGirdLoader)
    const selectedDealer = useAppSelector((state: RootState) => state.containers.dvsaFees.selectedDealer)
    const assignedPermissions = useAppSelector((state: RootState) => state.application.permissions)
    const verifyPermission = (checkPermissions: string[]) => hasPermission(checkPermissions, assignedPermissions)

    const isEffectiveDateModifiable = (props: any) => props.dataItem["effectiveDate"] > new Date(new Date().setDate(new Date().getDate() - 1))

    const toggleModel = (e: any, props: any) => {
        e.preventDefault()
        if (isEffectiveDateModifiable(props)) {
            dispatch(toggleDVSAModalAddEdit(true))
            dispatch(setSelectedExpetion(props.dataItem))
        } else
            return false
    }

    const NameLinkCell = (props: any) => (
        <td style={{ left: "0px" }}>
            <a
                href=" "
                style={{
                    textDecoration: `${isEffectiveDateModifiable(props)
                        ? "underline"
                        : ""}`,
                    cursor: `${isEffectiveDateModifiable(props)
                        ? "pointer"
                        : "not-allowed"}`,
                }}
                onClick={event => toggleModel(event, props)}
            >
                {props.dataItem[`${props.field}`] !== null
                    ? intl.formatDate(new Date(props.dataItem[`${props.field}`]), "dd/MM/yyyy")
                    : ""}
            </a>
        </td>
    )

    const CustomColumnCell = (props: GridCellProps) => (
        <td title={props.dataItem[`${props.field}`]}>{props.dataItem[`${props.field}`]}</td>
    )

    const GridHeaderCell = (props: any) => (
        <div className="text-end">
            <span title={props.title}>{props.title}</span>
            {props.children}
        </div>
    )

    const FeeColumnCell = (props: GridCellProps) => (
        <td className="text-end">
            {props.dataItem[`${props.field}`] !== 0
                ? intl.formatNumber(props.dataItem[`${props.field}`], { style: "currency", minimumFractionDigits: 2 })
                : ""}
        </td>
    )

    const TypeColumnCell = (props: GridCellProps) => <td className="text-end">{props.dataItem[`${props.field}`] ? "Exception" : "Default"}</td>

    const DvsaFeeGrid = (
        <MDBCol md="" className="pe-0 ps-1">
            <MDBCard className="mb-2 pt-1">
                <MDBCardBody className="p-2">
                    <Tooltip openDelay={100} position="bottom" anchorElement="pointer">
                        <Grid
                            data={dvsaFeeDefaults}
                            style={{
                                height: "calc(100vh - 6.2rem)",
                            }}
                        >
                            {verifyPermission(["DVSAFee.Add"]) && (
                                <GridToolbar>
                                    <Button
                                        fillMode={"flat"}
                                        themeColor="primary"
                                        className="buttons-container-button"
                                        iconClass="fa fa-plus"
                                        onClick={event => {
                                            dispatch(setSelectedExpetion(dvsaDefaultInit()))
                                            dispatch(toggleDVSAModalAddEdit(true))
                                        }}
                                    >
                                        Add
                                    </Button>
                                </GridToolbar>
                            )}
                            <GridColumn
                                field="effectiveDate"
                                title="Effective Date"
                                format="{0:d}"
                                width={"160px"}
                                cell={props =>
                                    verifyPermission(["DVSAFee.Edit"]) ? (
                                        <NameLinkCell {...props} />
                                    ) : (
                                        <td>
                                            {props.dataItem[`${props.field}`] === null
                                                ? intl.formatDate(
                                                    new Date(props.dataItem[`${props.field}`]),
                                                    "dd/MM/yyyy",
                                                )
                                                : ""}
                                        </td>
                                    )
                                }
                            />
                            <GridColumn field="updatedDate" title="Updated Date-Time" width={"200px"} />
                            <GridColumn field="updatedBy" cell={CustomColumnCell} width={"160px"} title="Updated By" />
                            <GridColumn
                                field="dayFee"
                                title="DVSA Fee"
                                width={"100px"}
                                cell={FeeColumnCell}
                                headerCell={GridHeaderCell}
                            />
                            <GridColumn
                                field="isException"
                                title="Fee Type"
                                width={"140px"}
                                cell={TypeColumnCell}
                                headerCell={GridHeaderCell}
                            />
                        </Grid>
                    </Tooltip>
                </MDBCardBody>
            </MDBCard>
        </MDBCol>
    )

    return (
        <>
            <AlertToastr />
            <MDBModal staticBackdrop animationDirection="right" show={isDvsaModalOpen} tabIndex="-1">
                <MDBModalDialog position="top right modal-lg" side>
                    <MDBModalContent className="full-height ">
                        <MDBModalHeader titleClass="lead">
                            <MDBModalTitle>{selectedDealer}</MDBModalTitle>
                            <MDBBtn
                                color="none"
                                className="btn-close"
                                onClick={() => dispatch(dvsaToggleAddEditModal(false))}
                            />
                        </MDBModalHeader>
                        {dvsaFeeGirdLoader && <SpinnerFragment />}
                        {DvsaFeeGrid}
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
            <AddEditDvsaFee />
        </>
    )
}

export default DvsaFeeRecord
